(function (angular) {
  angular
    .module('acme.view.application.membership.pricing.discounts.component.pricingCheckbox', ['ui.bootstrap'])
    .component('acmePricingCheckbox', {
      templateUrl: 'views/application/views/membership/pricing/discounts/components/pricing-checkbox/pricing-checkbox.component.tpl.html',
      controller: PricingCheckboxController,
      transclude: {},
      require: {
        ngModelCtrl: 'ngModel',
      },
      bindings: {
        ngModel: '<',
        indeterminate: '<',
      },
    });

  PricingCheckboxController.$inject = ['$element'];

  function PricingCheckboxController($element) {
    var ctrl = this;

    ctrl.$onInit = function () {
      $element.addClass('acme-pricing-checkbox');
      $element.attr('tabindex', -1);
    };

    ctrl.$onChanges = function (changes) {};

    ctrl.toggle = function () {
      ctrl.ngModelChange();
    };

    ctrl.ngModelChange = function () {
      ctrl.ngModelCtrl.$setViewValue(ctrl.ngModel);
    };
  }
})(window.angular);
